import Axios from 'axios'
import suffix from '@/api/requestPrefix'

export function download(fileData, filename, type) {
  var blob = new Blob([fileData], { type: type })
  if (window.navigator.msSaveOrOpenBlob) {
    navigator.msSaveBlob(blob, filename)
  } else {
    var a = document.createElement('a')
    var url = window.URL.createObjectURL(blob)
    if (!url) {
      url = window.webkitURL.createObjectURL(blob)
    }
    a.href = url
    a.download = filename
    a.click()
    window.URL.revokeObjectURL(url)
  }
}

const getFileBlob = async function getFileBlob(url, name) {
  const res = await request({ url: url, method: 'get', responseType: 'blob' })
  download(res.data, name, res.headers['content-type'])
}

export default {

  compute(data) {
    return Axios({
      url: suffix.projectUrl + '/jiJianStudy/compute',
      method: 'post',
      data: data
    })
  },
  selectRandomSubjects() {
    return Axios({
      url: suffix.projectUrl + '/jiJianStudy/selectRandomSubjects',
      method: 'get'
    })
  },

  rankList(projectId) {
    return Axios({
      url: suffix.projectUrl + '/jiJianStudy/rankList',
      method: 'get',
      params: { projectId: projectId }
    })
  },

  page(data) {
    return Axios({
      url: suffix.projectUrl + '/jiJianStudy/page',
      method: 'post',
      data: data
    })
  },

  list(data) {
    return Axios({
      url: suffix.projectUrl + '/jiJianStudy/list',
      method: 'post',
      data: data
    })
  },

  pdf(url) {
    return Axios({
      // url: 'https://wuxi-construction.oss-cn-shanghai.aliyuncs.com/d231eb9c-257d-4ffd-8c4c-eaeca58e6858.pdf',
      url: url,
      method: 'get',
      responseType: 'blob'
    })
  },

  incrBrowse(jijianId) {
    return Axios({
      url: suffix.projectUrl + `/jiJianStudy/incrBrowse/${jijianId}`,
      method: 'get'
    })
  },

  incrThumbs(jijianId) {
    return Axios({
      url: suffix.projectUrl + `/jiJianStudy/incrThumbs/${jijianId}`,
      method: 'get'
    })
  },

  getBrowseThumbs(jijianId) {
    return Axios({
      url: suffix.projectUrl + `/jiJianStudy/getBrowseThumbs/${jijianId}`,
      method: 'get'
    })
  },

  getBrowseRecordList(id, pageNum, pageSize, time) {
    return Axios({
      url: suffix.projectUrl + `/jiJianStudy/getBrowseRecordList`,
      method: 'get',
      params: { id: id, pageNum: pageNum, pageSize: pageSize, time: time }
    })
  },
  getThumbUpRecordList(id, pageNum, pageSize, time) {
    return Axios({
      url: suffix.projectUrl + `/jiJianStudy/getThumbUpRecordList`,
      method: 'get',
      params: { id: id, pageNum: pageNum, pageSize: pageSize, time: time }
    })
  }

}



// WEBPACK FOOTER //
// ./src/api/modules/jijian/index.js